import { render, staticRenderFns } from "./NovaPoshtaHead.vue?vue&type=template&id=4bd763ad&scoped=true"
import script from "./NovaPoshtaHead.vue?vue&type=script&lang=js"
export * from "./NovaPoshtaHead.vue?vue&type=script&lang=js"
import style0 from "./NovaPoshtaHead.vue?vue&type=style&index=0&id=4bd763ad&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd763ad",
  null
  
)

export default component.exports